// import _get from 'lodash/get'

import {
  ADMIN_GET_LOGIN_HISTORY_SUCCESS
} from './admin'

export const initialState = {
  list: [],
  pages: 0,
  last: false,
  currentPage: 0,
  loading: false
}

export const GET_LOGIN_HISTORY_REQUEST = 'GET_LOGIN_HISTORY_REQUEST'
export const GET_LOGIN_HISTORY_SUCCESS = 'GET_LOGIN_HISTORY_SUCCESS'
export const GET_LOGIN_HISTORY_ERROR = 'GET_LOGIN_HISTORY_ERROR'

export const getLoginHistory = ({ userId, page, size }) => (dispatch, getState, { httpRequest }) => {
  const currentUserId = getState().user.details.id

  dispatch({ type: GET_LOGIN_HISTORY_REQUEST })

  return httpRequest.get(`/account/${userId}/login-history/${page}`, {
    params: {
      size
    }
  })
    .then(res => {
      if (currentUserId === userId) {
        dispatch({
          type: GET_LOGIN_HISTORY_SUCCESS,
          history: res.data
        })
      } else {
        dispatch({
          type: ADMIN_GET_LOGIN_HISTORY_SUCCESS,
          history: res.data
        })
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      dispatch({
        type: GET_LOGIN_HISTORY_ERROR
      })
      console.error(err)
      return Promise.reject()
    })
}

const ACTION_HANDLERS = {
  [GET_LOGIN_HISTORY_REQUEST]: state => ({
    ...state,
    list: [],
    loading: true
  }),
  [GET_LOGIN_HISTORY_SUCCESS]: (state, { history }) => ({
    ...state,
    list: history.rows,
    count: history.count,
    last: history.last,
    pages: history.pages,
    loading: false
  })
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/login-history.js